export default "__VITE_ASSET__7797ed41__"